/**
 * main.js
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Polyfills for older browsers (must be first)
import './polyfills'

// Design tokens
import './styles/tokens.css'

// Plugins
import { registerPlugins } from '@/plugins'

// Components
import App from './App.vue'

// Composables
import { createApp } from 'vue'

export const app = createApp(App)

registerPlugins(app)

app.mount('#app')
